import Vue from 'vue'
import Vuex from 'vuex'
import { auth } from './auth'
import { buyer } from './buyer'
import { company } from './company'
import { cookies } from './cookies'
import { event } from './event'
import { gallery } from './gallery'
import { i18n } from './i18n'
import { initial } from './initial'
import { payment } from './payment'
import { pixels } from './pixels'
import { purchase } from './purchase'
import { seatsio } from './seatsio'
import { telecoming } from './telecoming'
import { tickets } from './tickets'
import { user } from './user'
Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    auth,
    buyer,
    cookies,
    event,
    company,
    gallery,
    i18n,
    initial,
    payment,
    pixels,
    purchase,
    seatsio,
    telecoming,
    tickets,
    user
  }
})
